import React from 'react';

import {
  Breakpoints,
  CTA,
  TextAlignment,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';

import { AppConstants } from '../../utils/app-constants';
import { onVWBasicLinkClick } from '../../tagging/tagging-helpers';
import { StyledCTA, StyledTitleContainer } from './styles';
import { useModelsCarouselContext } from '../../hooks/use-models-carousel-context';
import { useTrackingManager } from '../../hooks/use-tracking-manager';
import { useFeatureServices } from '../../hooks/use-feature-services';

export const CarouselTitle: React.FC = () => {
  const { translationHandler } = useModelsCarouselContext();
  const trackingManager = useTrackingManager();

  const { 'navigation-service': navigateService } = useFeatureServices();
  
  const handleTracking = () => {
    onVWBasicLinkClick(
      trackingManager,
      AppConstants.BuilderUrl,
      translationHandler('carousel.title.cta'),
    );
  };

  return (
    <StyledTitleContainer className="title-container">
      <TextCustom
        appearance={TextAppearance.headline300}
        style={{
          [Breakpoints.default]: {
            color: TextColor.primary,
            fontSize: TextSize.TextSize28,
            textAlign: TextAlignment.center,
            fontWeight: TextWeight.bold,
            lineHeight: TextLineHeight.TextLineHeight32,
          },
          [Breakpoints.b560]: {
            fontSize: TextSize.TextSize32,
            fontWeight: TextWeight.bold,
            lineHeight: TextLineHeight.TextLineHeight36,
          },
          [Breakpoints.b1280]: {
            fontSize: TextSize.TextSize44,
            fontWeight: TextWeight.bold,
            lineHeight: TextLineHeight.TextLineHeight52,
          },
        }}
      >
        {translationHandler('carousel.title')}
      </TextCustom>
      <CTA
        onClick={() => {
          handleTracking();
          const navigationObject = navigateService.navigateTo('mofa-standalone', {
            ['mofa-standalone']: '/'
          });
          navigationObject?.push();
        }}
        tag="a"
        emphasis="tertiary"
      >
        <TextCustom
          appearance={TextAppearance.headline200}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize20,
              textAlign: TextAlignment.center,
              lineHeight: TextLineHeight.TextLineHeight24,
            },
            [Breakpoints.b1280]: {
              fontSize: TextSize.TextSize24,
              lineHeight: TextLineHeight.TextLineHeight28,
            },
          }}
        >
          <StyledCTA className="cta-builder">
            {translationHandler('carousel.title.cta')}
          </StyledCTA>
        </TextCustom>
      </CTA>
    </StyledTitleContainer>
  );
};
